import ResourceApi from '../ResourceApi';

const LeaveAllowanceEstimateResource = {
  get: async (userId) => (await ResourceApi.get(`/resource/users/${userId}/leave-allowance-estimate`, {})).data,
};

export default LeaveAllowanceEstimateResource;
